function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import { Button, Card, Typography } from 'seagull';
import ChangesApprovalInfoBox from "../../../../components/ChangesApprovalInfoBox/ChangesApprovalInfoBox";
import { useOverlayContext, useStoreActions } from "../../../../contexts";
import { useApproveAmendments } from "../../../../hooks/useApproveAmendments";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { Intent } from "../../../../infra/access-control";
import { handleRequest } from "../../../../infra/utils";
import { timeModel } from "../../../../models";
import styles from "./ChangesSummary.module.scss";
import { getChangesSummary } from "./ChangesSummary.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ChangesSummary(props) {
  const {
    relationship,
    testId,
    isVendor,
    refresh
  } = props;
  const {
    SERVICE_TEMPLATE_BUNDLE = false
  } = useFeatureFlags();
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const approveAmendmentsRequest = useApproveAmendments();
  const [isApproving, setIsApproving] = useState(false);
  const [isDisabling, setIsDisabling] = useState(false);
  const changesSummary = useMemo(() => {
    return getChangesSummary(relationship, SERVICE_TEMPLATE_BUNDLE);
  }, [relationship, SERVICE_TEMPLATE_BUNDLE]);
  async function approveAmendments() {
    logBI(10150);
    setIsApproving(true);
    await approveAmendmentsRequest(_objectSpread(_objectSpread({}, relationship), {}, {
      onSuccess: () => refresh({
        silent: true
      })
    }));
    setIsApproving(false);
  }
  async function disableAutoApproval() {
    logBI(10151);
    setIsDisabling(true);
    const {
      success
    } = await handleRequest(api.relationship.stopAutoApproveAmendments(relationship.id));
    if (!success) {
      overlayContext.showErrorToast("Failed to disable auto-approval, please try again", "disable-auto-approval-error");
    } else {
      await refresh({
        silent: true
      });
      overlayContext.showSuccessToast("Disabled auto-approval", "disable-auto-approval-success");
    }
    setIsDisabling(false);
  }
  return changesSummary.length > 0 ? /*#__PURE__*/_jsx(Card, {
    disableSeparator: true,
    skin: "info",
    title: /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      weight: "normal",
      children: "Changes awaiting approval"
    }),
    padding: "m",
    testId: testId,
    actions: !isVendor && /*#__PURE__*/_jsx(Button, {
      intent: Intent.ApproveAllAmendments,
      size: "small",
      testId: "".concat(testId, "-approve"),
      loading: isApproving,
      tooltip: {
        placement: 'top',
        title: 'Approves all agreement amendments'
      },
      onClick: approveAmendments,
      children: "Approve"
    }),
    children: changesSummary.map((_ref, i) => {
      let {
        autoApprovalDate,
        changes,
        amendmentDate
      } = _ref;
      return /*#__PURE__*/_jsxs("div", {
        children: [amendmentDate && /*#__PURE__*/_jsxs(Typography, {
          className: styles.amendmentDate,
          testId: "".concat(testId, "-").concat(i, "-made-on"),
          children: ["Made on ", timeModel.formatDate(amendmentDate)]
        }), /*#__PURE__*/_jsx("ul", {
          className: styles.changes,
          children: changes.map((text, idx) => /*#__PURE__*/_jsx(Typography, {
            as: "li",
            variant: "paragraph2",
            className: styles.changeItem,
            testId: "".concat(testId, "-").concat(i, "-").concat(idx),
            children: text
          }, text))
        }), autoApprovalDate && /*#__PURE__*/_jsx(ChangesApprovalInfoBox, {
          testId: "".concat(testId, "-").concat(i, "-approval-info"),
          className: styles.approvalInfo,
          onDisable: disableAutoApproval,
          disabling: isDisabling,
          autoApprovalDate: autoApprovalDate,
          showDisableButton: !isVendor
        })]
      }, i);
    })
  }) : null;
}